import React, { createContext, useState, useContext, useEffect } from "react";
import { authAPI } from "../api/auth";
import Swal from "sweetalert2";

const AuthContext = createContext({});

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [token, setToken] = useState(localStorage.getItem("access_token"));

  useEffect(() => {
    const loadUser = async () => {
      const token = localStorage.getItem("access_token");
      if (token) {
        try {
          const response = await authAPI.getProfile();
          setUser(response.data);
        } catch (error) {
          console.error("Failed to load user:", error);
          logout();
        }
      }
      setLoading(false);
    };

    loadUser();
  }, []);

  const login = async (credentials) => {
    try {
      const response = await authAPI.login(credentials);
      const { access, refresh, user } = response.data;

      localStorage.setItem("access_token", access);
      localStorage.setItem("refresh_token", refresh);
      setToken(access);
      setUser(user);

      Swal.fire({
        icon: "success",
        title: "Login Successful!",
        text: `Welcome back, ${user.username}!`,
        timer: 2000,
        showConfirmButton: false,
      });

      return { success: true };
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Login Failed",
        text: error.response?.data?.detail || "Invalid credentials",
      });
      return { success: false, error: error.response?.data };
    }
  };

  const logout = async () => {
    const refreshToken = localStorage.getItem("refresh_token");
    if (refreshToken) {
      try {
        await authAPI.logout({ refresh: refreshToken });
      } catch (error) {
        console.error("Logout error:", error);
      }
    }

    localStorage.clear();
    setUser(null);
    setToken(null);

    Swal.fire({
      icon: "success",
      title: "Logged Out!",
      text: "You have been successfully logged out.",
      timer: 1500,
      showConfirmButton: false,
    });
  };

  const register = async (userData) => {
    try {
      await authAPI.register(userData);
      Swal.fire({
        icon: "success",
        title: "Registration Successful!",
        text: "You can now login with your credentials.",
        timer: 2000,
        showConfirmButton: false,
      });
      return { success: true };
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Registration Failed",
        text: error.response?.data?.message || "Please try again",
      });
      return { success: false, error: error.response?.data };
    }
  };

  const value = {
    user,
    token,
    loading,
    login,
    logout,
    register,
    isAuthenticated: !!user,
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};
